import Avatar from "components/shared/avatar";
import React from "react";

const AvatarWrapper = ({ add, imageUrl }) => (
    <div className="profile-head__avatar">
        <Avatar cname="profile-head__avatar-img" imageUrl={imageUrl} />
        <div className="profile-head__actions">
            {/* <div className="profile-head__action profile-head__action--top" onClick={del} title="Удалить" />
            <div className="profile-head__action profile-head__action--bottom" onClick={add} title="Обновить">
                Обновить
            </div> */}
            <div className="profile-head__action profile-head__action--update" onClick={add} title="Обновить">
                Обновить
            </div>
        </div>
    </div>
);

export { AvatarWrapper };
